import {
	allNamespaces,
	defaultNS,
	fallbackLng,
	supportedLngs,
} from './utils/i18n/i18n.shared.ts'

// i18next configuration. The language and namespace lists have a single
// source of truth in app/utils/i18n/i18n.shared.ts (D8: en + nl only;
// there has never been a 'settings' namespace — settings pages read 'app').
export default {
	supportedLngs: [...supportedLngs],
	// Language to use when the user language is not in supportedLngs
	fallbackLng,
	// The default namespace to use
	defaultNS,
	// Disabling suspense is recommended
	react: { useSuspense: false },
	// List of namespaces — must match the files in public/locales/<lng>/
	ns: [...allNamespaces],
}
